export default {
  success: 'success',
  warning: 'warning',
  danger: 'danger',
  informative: 'informative',
  error: 'error',
};
